import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { TransportManagementProfileListService } from './transport-management-profile-list.service';
import {
  TransportManagementProfileListInitialState,
  TransportManagementProfileListLoad,
} from './transport-management-profile-list.actions';
import { LIST_SERVER_PAGINATION_INITIAL_STATE, ListServerPaginationStateModel } from '../../../../../common/models';
import { NotificationService } from '../../../../../common/services/notification/notification.service';
import { PlannerProfile } from '../../../../models';
import { Error, CustomHttpErrorResponse } from '../../../../../common/constants/error';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export type TransportManagementProfileListStateModel = ListServerPaginationStateModel<PlannerProfile>;

const initialState: TransportManagementProfileListStateModel = LIST_SERVER_PAGINATION_INITIAL_STATE;

@State<TransportManagementProfileListStateModel>({
  name: 'transportManagementProfileList',
  defaults: initialState,
})
@Injectable()
export class TransportManagementProfileListState {
  constructor(
    private transportManagementProfileListService: TransportManagementProfileListService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getState(state: TransportManagementProfileListStateModel): TransportManagementProfileListStateModel {
    return state;
  }

  @Selector()
  static getItems(state: TransportManagementProfileListStateModel): PlannerProfile[] {
    return state.items;
  }

  @Selector()
  static getLoaded(state: TransportManagementProfileListStateModel): boolean {
    return state.loaded;
  }

  @Action(TransportManagementProfileListLoad)
  getTransportManagementProfileList(
    ctx: StateContext<TransportManagementProfileListStateModel>,
    { payload }: TransportManagementProfileListLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.transportManagementProfileListService.getTransportManagementProfileList(payload).pipe(
      map((transportManagementProfileList: TransportManagementProfileListStateModel) => {
        ctx.patchState({ ...transportManagementProfileList, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(TransportManagementProfileListInitialState)
  setInitialState(ctx: StateContext<TransportManagementProfileListInitialState>): void {
    ctx.setState(initialState);
  }
}
